import { Description } from '@zenterprise-inc/ui';

import IllustChat from '@/assets/illust-icons/fill-balloon-chat-more-gy2.svg';

const TrpCancelContent = () => {
  return (
    <div className="grow h-[calc(100vh-100px)] flex items-center">
      <Description.Guide
        subTitle="결제가 취소되었어요"
        description={'이 창을 닫고 결제 링크를 통해\n다시 결제를 시도해주세요'}
        imgChild={<IllustChat width={80} height={80} />}
      />
    </div>
  );
};

export default TrpCancelContent;
